import React from 'react';
import css from './FooterContainer.module.css';

const logoPath = '/static/logos/throttlex-logo.png';

const FooterContainer = () => {
  return (
    <footer className={css.root}>
      <div className={css.footerInner}>
        <div className={css.brandColumn}>
          <a href="/" className={css.logoLink} aria-label="ThrottleX homepage">
            <img src={logoPath} alt="ThrottleX" className={css.logo} />
          </a>

          <p>
            Premium outdoor rentals for lakes, dunes, trails, and weekend adventures.
          </p>
        </div>

        <div className={css.linkColumn}>
          <h3>Marketplace</h3>
          <a href="/s">Browse rentals</a>
          <a href="/#categories">Categories</a>
          <a href="/#marketplace-preview">Featured listings</a>
          <a href="/#how-it-works">How it works</a>
        </div>

        <div className={css.linkColumn}>
          <h3>Owners</h3>
          <a href="/signup">Start hosting</a>
          <a href="/l/new">Add a listing</a>
          <a href="/#hosting">Owner benefits</a>
          <a href="/#owner-requirements">Listing requirements</a>
        </div>

        <div className={css.linkColumn}>
          <h3>Support</h3>
          <a href="/#rental-rules">Safety guidelines</a>
          <a href="/#rental-rules">Rental rules</a>
          <a href="/#faq">FAQ</a>
          <a href="/p/contact">Contact</a>
        </div>

        <div className={css.linkColumn}>
          <h3>Legal</h3>
          <a href="/p/terms-of-service">Terms</a>
          <a href="/privacy-policy">Privacy</a>
          <a href="/p/host-standards">Host standards</a>
          <a href="/p/utv-renter-safety-checklist">UTV renter checklist</a>
          <a href="/login">Log in</a>
        </div>

        <div className={css.copyrightColumn}>
          <p>© 2026 ThrottleX. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default FooterContainer;
